import { FC } from 'react';
import { Card, Text } from 'roo-ui/components';

import RefundOptionsForm from '../RefundOptionsForm';

const RefundOptionsCard: FC = () => (
  <Card mb={[5, 8]}>
    <Text display="block" fontSize="lg" fontWeight="bold" mb={4} data-testid="refund-options-title">
      How would you like to receive your refund?
    </Text>

    <RefundOptionsForm />
  </Card>
);

export default RefundOptionsCard;
